export enum Constantes {
    ONZA = 7,
}